import Compteur from "../../../../common/CarteLead/Compteur";
import Puce from "../../../../common/CarteLead/Puce";
import { nbTachesFaites } from "../../../../common/CarteLead/tachesResume";
import { etatAgentInfo, resumeCompagnies } from "../LeadAutoAgent/agentTimelineHelpers";
import { tonEtatAgent } from "./tons";

// Compteurs et états affichés à côté des sections d'un lead auto : sur la
// barre d'accès de la carte (pastille d'état de l'agent) et dans les onglets
// du panneau (point coloré, plus court).
// L'état de l'agent est le résumé de graal (`lead.agent`, l'état le plus
// urgent parmi les compagnies, PER-2498). Quand plusieurs compagnies sont
// dans des états différents (ST1-2214), d'après `lead.agent.compagnies` rendu
// par la recherche ou la timeline de l'onglet une fois chargée, la barre
// montre une pastille par compagnie (son nom, l'icône et le ton de son état,
// l'état en toutes lettres dans l'infobulle) : un devis envoyé chez l'une ne
// se cache plus derrière l'échec de l'autre. Le panneau met un point par
// compagnie et dit « 2 compagnies ».
const compteurs = (lead) => {
  const taches = lead.tasks || [];
  const nbCommentaires = (lead.comments || []).length;
  const nbRetranscriptions = (lead.retranscriptions || []).length;
  return {
    commentaires: <Compteur plein={nbCommentaires > 0}>{nbCommentaires}</Compteur>,
    taches: (
      <Compteur plein={nbTachesFaites(taches) > 0}>
        {nbTachesFaites(taches)}/{taches.length}
      </Compteur>
    ),
    retranscription: <Compteur plein={nbRetranscriptions > 0}>{nbRetranscriptions}</Compteur>,
  };
};

export const extrasBarre = (lead, timeline = null) => {
  const agent = lead.agent || {};
  const etatAgent = etatAgentInfo(agent.etat);
  const compagnies = resumeCompagnies(timeline, agent);
  return {
    ...compteurs(lead),
    agent: compagnies.parCompagnie ? (
      <span className="la-puces">
        {compagnies.compagnies.map((c) => {
          const etat = etatAgentInfo(c.etat);
          return (
            <Puce key={c.compagnie} ton={tonEtatAgent(c.etat)} icone={etat.icon} titre={`${c.nom} : ${etat.label}`}>
              {c.nom}
              <span className="sr-only"> : {etat.label}</span>
            </Puce>
          );
        })}
      </span>
    ) : (
      <Puce ton={tonEtatAgent(agent.etat)} icone={etatAgent.icon} titre={agent.etatDetail || etatAgent.label}>
        {etatAgent.label}
      </Puce>
    ),
  };
};

export const extrasPanneau = (lead, timeline = null) => {
  const agent = lead.agent || {};
  const etatAgent = etatAgentInfo(agent.etat);
  const compagnies = resumeCompagnies(timeline, agent);
  return {
    ...compteurs(lead),
    agent: (
      <>
        {compagnies.parCompagnie ? (
          <span className="la-points" aria-hidden="true">
            {compagnies.compagnies.map((c) => (
              <span key={c.compagnie} className={`la-point la-point--${tonEtatAgent(c.etat)}`} />
            ))}
          </span>
        ) : (
          <span className={`la-point la-point--${tonEtatAgent(agent.etat)}`} aria-hidden="true" />
        )}
        {/* Compteur neutre : les points portent déjà le ton des états, le nombre n'est qu'une information. */}
        {compagnies.libelle && (
          <Compteur>
            <span title={compagnies.detail}>{compagnies.libelle}</span>
          </Compteur>
        )}
        <span className="sr-only">({compagnies.parCompagnie ? compagnies.detail : etatAgent.label})</span>
      </>
    ),
  };
};
